import {
    renderAccount,
    renderAircraft,
    renderFlights,
    renderImagery,
    renderLogbook,
    renderLogbookCTA,
    renderMap,
} from 'ff/common/components/FFMenuV2/MenuItems';
import renderDivider from 'ff/common/components/FFMenuV2/MenuItems/Divider';
import fillSpace from 'ff/common/components/FFMenuV2/MenuItems/FillSpace';

export default function RenderNoSubscriptionMenu() {
    return [
        renderFlights,
        renderMap,
        renderImagery,
        renderAircraft,
        renderLogbook,
        renderDivider,
        renderAccount,
        renderLogbookCTA,
        fillSpace.bind(null, { flex: '1' }),
    ];
}
